import React from "react";
import { useSearchParams } from "react-router-dom";
import ProductDetailComponent from "./ProductDetailComponent";

export default function ProductList() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    if (!id) return <p>محصولی انتخاب نشده است.</p>;

    return <ProductDetailComponent id={id} />;
}
